const getEnumLabel = (
  options: { value: string; label: string }[],
  value: string,
) => {
  const match = options.find((option) => option.value === value);
  return match?.label;
};

export default getEnumLabel;
